import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { Container, Draggable } from 'react-smooth-dnd'
import Line from 'features/list/components/line'
import { utils } from 'gipsy-misc'

class DraggableList extends PureComponent {
  static propTypes = {
    /* if dragging a task in the page */
    dragging: PropTypes.bool,
    group: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired,
    highlightIds: PropTypes.array,
    onClick: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onDragStart: PropTypes.func.isRequired,
    onDragEnd: PropTypes.func.isRequired
  }

  state = {
    draggingHover: false
  }

  onDrop = result => {
    this.props.onDrop({
      ...result,
      group: this.props.group
    })
  }

  onMouseEnter = () => {
    if (this.props.onMouseEnter) {
      this.props.onMouseEnter()
    }
  }

  onMouseLeave = () => {
    if (this.props.onMouseLeave) {
      this.props.onMouseLeave()
    }
  }

  onDragEnter = () => {
    this.setState({
      draggingHover: true
    })
  }

  onDragLeave = () => {
    this.setState({
      draggingHover: false
    })
  }

  /* data passed to onDragStart, onDrop */
  getChildPayload = index => {
    const { list } = this.props

    return { item: list[index], index }
  }

  render() {
    const { list, group, highlightIds, onComplete, onClick, onChange, onDragStart, onDragEnd, dragging } = this.props
    const { draggingHover } = this.state
    return (
      <ListBody
        className="list-body"
        dragging={dragging}
        draggingHover={draggingHover}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        <Container
          onDrop={this.onDrop}
          onDragEnd={onDragEnd}
          onDragStart={onDragStart}
          onDragEnter={this.onDragEnter}
          onDragLeave={this.onDragLeave}
          dragClass="dragging"
          lockAxis="y"
          groupName="todoItem"
          getChildPayload={this.getChildPayload}>
          {list.map((todoItem, index) =>
            todoItem.type === 'event' || !!(todoItem.pin && todoItem.pin.time) ? (
              <Line
                ref={ref => {
                  this.lines = this.line || {}
                  this.lines[todoItem.id] = ref
                }}
                key={todoItem.id}
                group={group}
                item={todoItem}
                highlight={highlightIds.indexOf(todoItem.id) !== -1}
                showWhenDate={utils.datetime.isGroupUpcoming(group)}
                onClick={onClick}
                onComplete={onComplete}
                onChange={onChange}
              />
            ) : (
              <Draggable key={todoItem.id}>
                <Line
                  ref={ref => {
                    this.lines = this.line || {}
                    this.lines[todoItem.id] = ref
                  }}
                  key={todoItem.id}
                  group={group}
                  item={todoItem}
                  highlight={highlightIds.indexOf(todoItem.id) !== -1}
                  showWhenDate={utils.datetime.isGroupUpcoming(group)}
                  onClick={onClick}
                  onComplete={onComplete}
                  onChange={onChange}
                  isDraggable={true}
                />
              </Draggable>
            )
          )}
        </Container>
      </ListBody>
    )
  }
}

const ListBody = styled.div`
  border: 1px solid transparent;
  transition: min-height 0.2s linear;
  min-height: 0px;
  padding: 8px;
  width: 100%;
  border-radius: 8px;
  .smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {
    overflow: visible;
    cursor: grab;
  }
  .smooth-dnd-container.vertical > *:last-child,
  .smooth-dnd-container.vertical > *:last-child .line-container {
    margin-bottom: 0px;
  }
  ${({ dragging, draggingHover }) =>
    dragging &&
    css`
      background-color: white;
      min-height: 48px;
      padding: 8px;
      .line-container .line {
        pointer-events: none;
      }
      ${draggingHover &&
        css`
          box-shadow: 0 0px 12px #e6e6e6;
          border: 1px solid #e6e6e6;
        `}
    `}
`

export default DraggableList



// WEBPACK FOOTER //
// ./src/features/list/components/draggableList/index.js